var React = require('react');

function Arrowright (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"},React.createElement("path",{"d":"M13.8,2.128a.75.75,0,0,0-1.061,0L10.613,4.249a.75.75,0,0,0,0,1.061l4.644,4.644H1.5a.75.75,0,0,0-.75.75v3a.75.75,0,0,0,.75.75H15.257L10.613,19.1a.75.75,0,0,0,0,1.061l2.121,2.121a.75.75,0,0,0,1.061,0l9.016-9.015a1.5,1.5,0,0,0,0-2.122Z","fill":"current","stroke":"current","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"})));
}

Arrowright.defaultProps = {"version":"1.1","viewBox":"0 0 140 140"};

module.exports = Arrowright;

Arrowright.default = Arrowright;
